import React, { useEffect, useState } from "react"
import HamburgerMenu from "./HamburgerMenu"
import { Link } from "react-router-dom"
import axios from "axios"
import GetCSFR from "../../hooks/userAuthentication/GetCSFR"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBagShopping } from "@fortawesome/free-solid-svg-icons"
import CheckoutForm from "../general/merchandise-preview/CheckoutForm"

interface HeaderProps {
    useCase?: "default" | "protected" | "merchandise" | "onboarding";
    url?: string;
}

export default function Header({ useCase: initialUseCase, url}: HeaderProps) {
    const [useCase, setUseCase] = useState(initialUseCase || "default")
    const [displayCheckout, setDisplayCheckout] = useState<boolean>(false)
    const csrfToken = GetCSFR({ name: "csrftoken" })

    // Check if session cookie exists
    function checkSessionCookie() {
        return document.cookie.split("; ").some((cookie) => cookie.startsWith("sessionid="))
    }

    // Check if the current time is a multiple of 20 minutes
    function isCurrentTimeMultipleOf20Minutes() {
        const now = new Date()
        const minutes = now.getMinutes()
        return minutes % 10 === 0
    }

    useEffect(() => {
        // If no useCase is passed and session Id exists, then check authentication status every 10 minutes
        if (!initialUseCase || useCase==='default' && (checkSessionCookie() || isCurrentTimeMultipleOf20Minutes())) {
            axios.get(`${process.env.REACT_APP_SKILLJA_URL}/auth_status/`, {
                    headers: {
                        "X-CSRFToken": csrfToken,
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                })
                .then((res) => {
                    if (res.data.is_logged_in === true) {
                        setUseCase("protected")
                    } else {
                        setUseCase("default")
                    }
                })
                .catch((error) => {
                    console.error("Error checking authentication", error)
                })
        }
    }, [])

    return (
        <>
            {useCase && useCase === "default" ? (
                <div className="w-full flex items-center px-4 pt-6 pb-4 mb-8 lg:px-20 xl:px-36">
                    <Link to="/" className="mr-auto ml-0 my-auto">
                        <img
                            src={require("../../assets/new-skillja-logo.png")}
                            className="w-16 lg:w-20"
                            alt="SkillJa logo"
                        />
                    </Link>
                    <HamburgerMenu useCase="public" />
                </div>
            ) : useCase && useCase === "protected" ? (
                <div className="w-full flex items-center px-4 pt-6 pb-4 mb-8 lg:px-20">
                    <Link to="/home-feed" className="mr-auto ml-0 my-auto">
                        <img
                            src={require("../../assets/new-skillja-logo.png")}
                            className="w-16 lg:w-20"
                            alt="SkillJa logo"
                        />
                    </Link>
                    <HamburgerMenu useCase="authorized" url={url} />
                </div>
                ) : useCase && useCase === "merchandise" ? (
                        <div className="w-full flex items-center px-4 pt-6 pb-4 mb-8 lg:px-20">
                            <Link to="/" className="mr-auto ml-0 my-auto">
                                <img
                                    src={require("../../assets/new-skillja-logo.png")}
                                    className="w-16 lg:w-20"
                                    alt="SkillJa logo"
                                />
                            </Link>
                            <FontAwesomeIcon 
                                className="text-2xl lg:text-3xl text-main-grey-200 mr-7 lg:mr-10 my-auto hover:text-main-green-500 cursor-pointer"
                                icon={faBagShopping} 
                                onClick={()=>setDisplayCheckout(true)}
                                tabIndex={0}
                            />
                            <HamburgerMenu useCase="public" />
                        </div>
                    )
                    :
                        (
                            <div className="w-full flex items-center px-4 pt-9 pb-4 mb-8 lg:px-20">
                                <Link to="/" className="cursor-pointer">
                                    <img
                                        src={require("../../assets/new-skillja-logo.png")}
                                        className="w-16 mr-auto ml-0 my-auto lg:w-20"
                                        alt="SkillJa logo"
                                    />
                                </Link>
                            </div>
                        )
            }
            {displayCheckout && <CheckoutForm displayForm={setDisplayCheckout} />}
        </>
    )
}
